import type { CSSProperties } from 'react';
import { Icon } from './Icon';
import { copy, type Language } from '../content';
import { useScrollProgress } from '../motion/useScrollProgress';

type TeamFlowProps = { language: Language };

/**
 * The handoff chain, built in markup rather than baked into an image: the connector fills
 * and the discs light up as the section scrolls, and every label stays live text so the
 * English switch, search engines and screen readers all still work.
 */
export function TeamFlow({ language }: TeamFlowProps) {
  const text = copy[language].team;
  const ref = useScrollProgress<HTMLDivElement>();

  return (
    <div className="team-flow" ref={ref}>
      <div className="team-flow__track" aria-hidden="true">
        <span className="team-flow__fill" />
        <span className="team-flow__pulse" />
      </div>
      <ol className="team-flow__steps" style={{ '--count': text.steps.length } as CSSProperties}>
        {text.steps.map((step, index) => (
          <li key={step.role} style={{ '--i': index } as CSSProperties}>
            <span className="team-flow__disc">
              <Icon name={step.icon} />
              <i>{index + 1}</i>
            </span>
            <strong>{step.role}</strong>
            <small>{step.action}</small>
          </li>
        ))}
      </ol>
    </div>
  );
}
